export default __webpack_public_path__ + "static/media/faqs.1b227991.svg";